module.exports = __webpack_public_path__ + "static/media/bg-drinks_mb.a07bc3a1.jpg";